// material-ui

import truckappointmenticon from '../../../assets/images/truck-appointment.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const TruckAppointmentIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={truckappointmenticon} alt="Truck appointment" width="22"  />
    );
};

export default TruckAppointmentIcon;